"use memo"

import {
  AgxLoadedFileDropzone,
  BrowserLoadedFile,
} from '@urbanx/agx.ui-components2'

interface ContractUploadStepProps {
  loadedFile?: BrowserLoadedFile
  disabled?: boolean
  onFileLoaded: (loadedFile: BrowserLoadedFile) => void
  onFileCleared: () => void
}

const ContractUploadStep = ({
  loadedFile,
  disabled,
  onFileLoaded,
  onFileCleared,
}: ContractUploadStepProps) => (
  <AgxLoadedFileDropzone
    id="contractUpload"
    dataTestId="contract-upload-dropzone"
    accept=".pdf"
    extensions={['pdf']}
    multiple={false}
    maxFileSizeMB={30}
    loadedFile={loadedFile}
    disabled={disabled}
    onFileLoaded={onFileLoaded}
    onFileCleared={onFileCleared}
    fillVertical
  />
)

export default ContractUploadStep
